import { createApplicationService } from "./base/applicationServiceBase";
import { AccountsAPI } from "api/axios.config";

//-------------------------------------------
//           API Functions
//-------------------------------------------

const VATS_BASE = "/VatCodes";

const fetchVatsAPI = () => AccountsAPI.get(`${VATS_BASE}`);

const addNewVatAPI = (data) =>
  AccountsAPI.post(VATS_BASE, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateVatAPI = (id, data) =>
  AccountsAPI.patch(`${VATS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

//-------------------------------------------

const baseService = createApplicationService({
  name: "vats",
  apiFetchFn: fetchVatsAPI,
  apiAddFn: addNewVatAPI,
  apiUpdateFn: updateVatAPI,
});

const vatReducer = baseService.reducer;
const getVats = baseService.getData;
const addVat = baseService.addData;
const updateVat = baseService.updateData;
const useVats = baseService.useData;

const getActiveVats = async () => {
  const allVats = await getVats();
  return allVats?.filter((item) => item.includeInVatReturn) || [];
};

const useActiveVats = () => {
  const { data, loading } = useVats();
  const filteredData = data?.filter((item) => item.active) || [];
  return { loading, data: filteredData };
};

export {
  vatReducer,
  getVats,
  addVat,
  updateVat,
  useVats,
  useActiveVats,
  getActiveVats,
};
